<template>
  <van-popup
    v-model="visible"
    get-container="body"
    :close-on-click-overlay="false"
    :style="[
      { backgroundColor: 'transparent', overflowY: 'visible' },
      customStyle
    ]"
    @close="$emit('close')"
    @closed="$emit('closed')"
    @open="$emit('open')"
    @opened="$emit('opened')"
  >
    <div :class="[$style.popup, $style[`popup-${size}`]]">
      <btn-close @click="visible = false" :class="$style['btn-close']" />
      <slot />
    </div>
  </van-popup>
</template>

<script>
import BtnClose from "../BtnClose";

export default {
  name: "PopupFrame",
  components: { BtnClose },
  props: {
    /**
     * 弹窗尺寸
     * @values sm, lg
     */
    size: { type: String, default: "sm" },
    /**
     * 自定义样式
     */
    customStyle: { type: [Object, String], default: () => ({}) }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" module>
.popup {
  color: #784831;
  font-size: 0.26rem;
  line-height: 1.5;

  em {
    color: #c95c0c;
  }

  &-sm {
    .size(10.22rem, 6.03rem);
    .background-fill("./images/bg-sm.png");

    padding: 0.8rem 1.15rem 0.6rem 0.72rem;

    .btn-close {
      position: absolute;
      top: -0.55rem;
      right: 0.05rem;
    }
  }

  &-lg {
    .size(7.24rem, 9.85rem);
    .background-fill("./images/bg-lg.png");

    padding: 0.58rem 0.56rem 0.26rem 0.57rem;

    .btn-close {
      position: absolute;
      top: -0.8rem;
      right: -0.5rem;
    }
  }
}
</style>
